import styled from "styled-components";

export const ModalBodySug = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 0 32px 10px 32px;
    background-color: var(--bg);
    border-radius: 0.5rem;
    .modal-header{
        border-bottom: 0;
        padding-left: 0;
        padding-right: 0;
        & .btn-close {
            margin-left: calc(-.5 * var(--bs-modal-header-padding-y));
            margin-right: auto;
        }
    }
`
export const PeopleContactBtnsWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 12px;
    align-items: center;
    margin-top: 24px;
    button{
        min-height: 32px;
        min-width: 32px;
        svg{
            width: auto !important;
            height: auto !important;
        }
        span{
            color: var(--white) !important;
        }
    }
    
`